// Definir las funciones como constantes exportadas
export const blockUI = function(message){
  // Solo bloquear si KTApp está disponible
  if (typeof window !== 'undefined' && window.KTApp && typeof window.KTApp.blockPage === 'function') {
    window.KTApp.blockPage({
      overlayColor: '#000000',
      state: 'primary',
      message: message
    });
  }
}

export const unblockUI = function(){
  // Solo desbloquear si KTApp está disponible
  if (typeof window !== 'undefined' && window.KTApp && typeof window.KTApp.unblockPage === 'function') {
    window.KTApp.unblockPage();
  }
}

// Exponer globalmente para mantener compatibilidad con el código existente
if (typeof window !== 'undefined') {
  window.blockUI = blockUI;
  window.unblockUI = unblockUI;
}

// Configurar toastr solo si está disponible (los plugins de Keen lo registran más tarde)
if (typeof window !== 'undefined' && window.toastr) {
  window.toastr.options = {
    closeButton: true,
    debug: false,
    newestOnTop: false,
    progressBar: false,
    positionClass: 'toast-top-right',
    preventDuplicates: false,
    onclick: null,
    showDuration: '300',
    hideDuration: '1000',
    timeOut: '5000',
    extendedTimeOut: '1000',
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut'
  };
}

export const getMimeSVG = function(path) {
   if(path == undefined){
    return;
   }
    const icons = ['jpg','jpeg','png','svg','xml','doc','docx','pdf','ppt','xls','xlsx','zip'];
    const ext = path.split('.').pop();

    return icons.includes(ext) ? `${ext}.svg` : `file.svg`;
}

// Exponer globalmente para mantener compatibilidad
if (typeof window !== 'undefined') {
  window.getMimeSVG = getMimeSVG;
}
